import { CheckBox } from '@room-match/shared-ui-components';
import React, { useState } from 'react';
import IMedia from 'shared/interfaces/IMedia';
import { ImageElement, ImageItemCont } from './Item.styles';
import noImg from './no-image.png';

interface Props {
  item: IMedia;
  checked?: boolean;
  handleSelect?: (media: IMedia) => void;
  onClick?: () => void;
  renderElement?: React.ReactNode;
}

const ImageBinItem: React.FC<Props> = ({ item, checked, handleSelect, onClick, renderElement }) => {
  const [source, setSource] = useState<string>(
    item.attributes.modified_attachment_url ? item.attributes.modified_attachment_url : item.attributes.attachment_url,
  );
  const [show, setShow] = useState(false);

  return (
    <ImageItemCont onMouseOver={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      {handleSelect && (
        <div style={{ position: 'absolute', top: -5, left: -5 }}>
          <CheckBox checked={checked} onClick={() => handleSelect(item)} />
        </div>
      )}
      {show ? renderElement : null}
      <ImageElement
        onClick={() => onClick && onClick()}
        draggable={false}
        src={`${source}/0x144`}
        onError={() => setSource(noImg)}
      />
    </ImageItemCont>
  );
};

export default ImageBinItem;
